(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dashboard-management', {
                parent: 'entity',
                url: '/dashboard?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management.html',
                        controller: 'DashboardManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: null,
                    itemsPerPageChosen: null,
                    predicates: {}
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('dashboard-detail', {
                parent: 'dashboard-management',
                url: '/dashboard/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-detail.html',
                        controller: 'DashboardManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Dashboard', function ($stateParams, Dashboard) {
                        return Dashboard.get({id: $stateParams.id});
                    }]
                }
            })
            .state('dashboard-new', {
                parent: 'dashboard-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-dialog.html',
                        controller: 'DashboardManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            name: null,
                            url: null,
                            description: null,
                            frameReference: null,
                            id: null
                        };
                    }
                }
            })
            .state('dashboard-edit', {
                parent: 'dashboard-management',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.dashboard.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/dashboard/dashboard-management-dialog.html',
                        controller: 'DashboardManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Dashboard', function ($stateParams, Dashboard) {
                        return Dashboard.get({id: $stateParams.id});
                    }]
                }
            })
            .state('dashboard.delete', {
                parent: 'dashboard-management',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/dashboard/dashboard-management-delete-dialog.html',
                        controller: 'DashboardManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Dashboard', function (Dashboard) {
                                return Dashboard.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('dashboard-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
